import { createStore, compose, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { createReduxHistoryContext } from 'redux-first-history';
import { rootReducer } from '../reducers';

let store = null;

export function configureStore(history, initialState = {}) {
  // redux-first-history discards the unlisten returned by history.listen, so keep it to allow cleanup on unmount
  let unlistenHistory = () => {};
  const trackedHistory = Object.create(history, {
    listen: {
      value: (listener) => {
        unlistenHistory = history.listen(listener);
        return unlistenHistory;
      },
    },
  });

  const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({
    history: trackedHistory,
  });

  const middlewares = [routerMiddleware, thunk];
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  store = createStore(
    rootReducer(routerReducer), // root reducer with router state
    initialState,
    composeEnhancers(applyMiddleware(...middlewares))
  );

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../reducers', () => {
      const nextRootReducer = require('../reducers').default; // eslint-disable-line global-require
      store.replaceReducer(nextRootReducer(routerReducer));
    });
  }

  const reduxHistory = createReduxHistory(store);

  return { store, reduxHistory, unlistenHistory };
}

export function getStore() {
  return store;
}
